// src/lib/duckdb/catalog.ts
import type { AsyncDuckDBConnection } from "@duckdb/duckdb-wasm";
import { arrowTableToObjects } from "@/lib";

/**
 * List all logical relations (tables and views) in the database.
 * Uses the SQLite-compatible sqlite_master catalog table.
 */
export async function listRelations(
  conn: AsyncDuckDBConnection
): Promise<string[]> {
  const sql = `
    SELECT name
    FROM sqlite_master
    WHERE type IN ('table','view')
      AND name NOT LIKE 'sqlite_%';
  `;
  const result = await conn.query(sql);
  const rows = arrowTableToObjects(result);
  return rows
    .map((r: any) => r.name || r.table || r.TABLE_NAME || r.TABLE)
    .filter(Boolean as any) as string[];
}
